export const sameYMD = (a, b) => {
    if (!a || !b) return false;
    const da = new Date(a);
    const db = new Date(b);
    return (
        da.getFullYear() === db.getFullYear() &&
        da.getMonth() === db.getMonth() &&
        da.getDate() === db.getDate()
    );
};

export const ymd = (d) => {
    const x = new Date(d);
    const mm = `${x.getMonth() + 1}`.padStart(2, "0");
    const dd = `${x.getDate()}`.padStart(2, "0");
    return `${x.getFullYear()}-${mm}-${dd}`;
};

export const formatFechaLarga = (isoOrDate) => {
    const date = new Date(isoOrDate);
    const diaSemana = new Intl.DateTimeFormat("es-ES", { weekday: "long" })
        .format(date)
        .replace(/^\w/, (c) => c.toUpperCase());

    const fechaCorta = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).format(date);

    return `${diaSemana} ${fechaCorta}`;
};
